module.exports = __webpack_public_path__ + "static/img/sapwoodCellars_join_us.418853d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sapwoodCellars_join_us.jpg
// module id = 304
// module chunks = 1